module.exports = __webpack_public_path__ + "media/fonts/Oricons-fd6969d5b182a9e3f08aaf05ecfcd458.eot";